import { v4 as uuid } from 'uuid';

export default class Notifications {
  static SUBSCRIPTION_CHANGE_KEY = 'SUBSCRIPTION_CHANGE';

  applicationServerKey: any;

  listeners: any;

  pushManager: any;

  serviceWorker: any;

  static urlB64ToUint8Array(base64String: any) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }

  constructor(pushManager: any, applicationServerKey: any) {
    this.applicationServerKey = Notifications.urlB64ToUint8Array(applicationServerKey);
    this.pushManager = pushManager;
    this.serviceWorker = navigator.serviceWorker;

    this.listeners = {};
  }

  subscribe() {
    const { applicationServerKey, pushManager } = this;

    return pushManager
      .subscribe({
        applicationServerKey,
        userVisibleOnly: true,
      })
      .then((subscription: any) => {
        this.callListeners(Notifications.SUBSCRIPTION_CHANGE_KEY, subscription);
        return subscription;
      });
  }

  getSubscription() {
    return this.pushManager.getSubscription();
  }

  onSubscriptionChange(cb: any) {
    this.addListener(Notifications.SUBSCRIPTION_CHANGE_KEY, cb);
  }

  getRemoveListenerFunc(uuid: any, type: any) {
    return () => delete this.listeners[type][uuid];
  }

  addListener(type: any, cb: any) {
    const { listeners } = this;
    const id = uuid();

    if (typeof listeners[type] !== 'object') {
      listeners[type] = {};
    }

    listeners[type][id] = cb;

    return this.getRemoveListenerFunc(id, type);
  }

  callListeners(type: any, data: any) {
    const listenerObj = this.listeners[type];
    for (const id in listenerObj) {
      if (typeof listenerObj[id] === 'function') {
        listenerObj[id](data);
      }
    }
  }

  listen() {
    const { serviceWorker, listeners } = this;

    serviceWorker.addEventListener('message', (event: any) => {
      const { data } = event;

      if (data && data.type) {
        this.callListeners(data.type, data);
      }
    });
  }
}
